import React, { useState, useEffect } from "react";
import { Calendar, momentLocalizer, Event } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import dayjs, { Dayjs } from "dayjs";
import { useStyles } from "../../../theme/appStyles";
import '../../../App.css'; // Import your custom styles
import {
  ICompanyDetails,
  ICustomer,
  IProductPopUP,
  ITaxes,
  IEmailTemplate,
  IDriver
} from "../../../Api/Interface/api.interface";
import {
  useCreateCustomerMutation,
  useCreateWorkOrderMutation,
  useGetAllSearchCompanyQuery,
  useGetAllWorkOrderHistoryQuery,
  useGetAllInvoiceHistoryQuery,
  useGetCompanyQuery,
  useGetCustomerQuery,
  useGetLastWorkOrderIdQuery,
  useGetProductQuery,
  useGetTaxQuery,
  useGetWorkOrderQuery,
  useUpdateInvoiceStatusQuery,
  useGetEmailTemplateQuery,
  useGetAllInvoiceQuery,
  useGetDriverQuery,
  useGetAllInquiryQuery
} from "../../../Api/attoDeskApi";
import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
  DialogTitle,
  Select
} from "@mui/material";
import { useNavigate } from "react-router-dom"; 
import {InquiryStatus } from "../../../Core/Enum/enum";

import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import interactionPlugin from '@fullcalendar/interaction';

// Define localizer
const localizer = momentLocalizer(moment);

// Define TypeScript interface for a booking
interface Booking {
  id: number;
  gameType: string;
  customerName: string;
  startTime: string;
  endTime: string;
}

  interface IProduct {
    productName: string;
    productDescription: string;
    productImg: String | null;
    numberOfPassengers: number | null;
    transferType: string;
    transferTypeFrom: string;
    transferTypeTo: string;
    transferTypeDescription: string;
    departureDateTime: Dayjs | null;
    returnDateTime: Dayjs | null;
    departureAddress: string;
    destinationAddress: string;
    multiDestination: string;
    quantity: number | null;
    price: number | null;
    tax: number | null;
    taxAmount: number | null;
    total: number;
    taxId: number | null;
    unitPriceWithDiscount: number | null;
    unitTotalWithDiscount: number;
    productType: string;
    productLongDescription: string;
    productShortDescription: string;
  }
  
  interface IDiscount {
    value: number | null;
    description: string;
  }
  
  interface IQuoteWorkOrder {
    id: number;
    quoteWorkOrderCompanyId: number;
    quoteWorkOrderCustomerId: string;
    quoteWorkOrderNo: string;
    quoteWorkOrderIssueDate: Dayjs;
    quoteWorkOrderDueDate: Dayjs;
    quoteWorkOrderAmount: number | null;
    quoteWorkOrderStatus: number;
    quoteWorkOrderSale: IProduct[];
    quoteWorkOrderDiscount: string;
    quoteWorkOrderSubTotal: string;
    quoteWorkOrderSaleGrandTotal: string;
    quoteWorkOrderSaleDiscountDescription: IDiscount[];
    customer: ICustomer;
    company: ICompanyDetails;
    quoteWorkOrderCustomerRemark: string;
    quoteWorkOrderCustomerMemo: string;
    quoteWorkOrderSaleDiscount: string;
    quoteWorkOrderSaleSubTotal: string;
    created_by: number;
    created_at: string;
    mainStatus: number;
    invoiceId: number;
    payment_id: string;
  }
  interface IInvoice {
    id: number;
    work_order_id: string;
    quoteWorkOrderCompanyId: number;
    quoteWorkOrderCustomerId: string;
    quoteWorkOrderNo: string;
    quoteWorkOrderIssueDate: Dayjs;
    quoteWorkOrderDueDate: Dayjs;
    quoteWorkOrderAmount: number | null;
    quoteWorkOrderStatus: number;
    quoteWorkOrderSale: IProduct[];
    quoteWorkOrderDiscount: string;
    quoteWorkOrderSubTotal: string;
    quoteWorkOrderSaleGrandTotal: string;
    quoteWorkOrderSaleDiscountDescription: IDiscount[];
    customer: ICustomer;
    company: ICompanyDetails;
    quoteWorkOrderCustomerRemark: string;
    quoteWorkOrderCustomerMemo: string;
    quoteWorkOrderSaleDiscount: string;
    quoteWorkOrderSaleSubTotal: string;
    created_by: number;
    created_at: string;
    mainStatus: number;
    invoiceId: number;
    payment_id: string;
    amount_paid: number;
    due_amount: number;
  }

  const getInquiryStatusLabel = (statusCode: number): string => {
    switch (statusCode) {
      case InquiryStatus.New:
        return "New";
      case InquiryStatus.Contacted:
        return "Contacted";
      case InquiryStatus.FollowUp:
        return "Follow-up";
      case InquiryStatus.Converted:
        return "Converted";
      case InquiryStatus.Closed:
        return "Closed";
      default:
        return "Unknown Status";
    }
  };

  const getInquiryStatusColor = (status: number): string => {
  switch (status) {
    case InquiryStatus.New:
      return "#4caf50"; // green
    case InquiryStatus.Contacted:
      return "#2196f3"; // blue
    case InquiryStatus.FollowUp:
      return "#ff9800"; // orange/yellow
    case InquiryStatus.Converted:
      return "#9e9e9e"; // grey
    case InquiryStatus.Closed:
      return "#f44336"; // red
    default:
      return "#9e9e9e"; // fallback grey
  }
};

  

  // Define TypeScript type for events
interface CalendarEvent extends Event {
  title: string;
  start: Date;
  end: Date;
  
}
const BookingCalendar = () => {
  const [events, setEvents] = useState<CalendarEvent[]>([]);
   const classes = useStyles();
   const theme = useTheme();
   const navigate = useNavigate();
   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const { data : inquiryData, isLoading, isError, refetch } = useGetAllInquiryQuery({
    searchText: "",
    id: "",
    customerId: "",
  });

  // const { data: workOrderData, isLoading: workIsLoading, isError: workOrderError } = useGetWorkOrderQuery({ searchText: "", id: "" });
  // const { data: invoiceData, isLoading: invoiceIsLoading, isError: invoiceError } = useGetAllInvoiceQuery({ searchText: "", id: "", quoteWorkOrderCustomerId: "", quoteWorkOrderCustomerProjectId: "" });
  // const { data: companyData, isLoading: companyLoading } = useGetCompanyQuery({searchText: "", id: "",});
  const {data: customerData,isLoading: customerIsLoading,isError: cutomerError,refetch: cutomerRefetch,} = useGetCustomerQuery({searchText: "",id: "",});
  
  // const { data: driverData,  isLoading: driverIsLoading, isError: driverError,refetch: driverRefetch,} = useGetDriverQuery({ searchText: "",id: "",});
 // const capitalize = (str: string) => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
 const capitalize = (str: string | null | undefined): string => {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
    const [selectedCompany, setSelectedCompany] = useState<string>("");
    const [selectedCustomer, setSelectedCustomer] = useState<string>("");
    const [selectedStatus, setSelectedStatus] = useState<string>("");

  React.useEffect(() => {
    document.documentElement.style.setProperty("--primary-color", theme.palette.primary.main);
    document.documentElement.style.setProperty("--primary-dark", theme.palette.primary.dark);
  }, [theme]); 


  // useEffect(() => {
  //   let bookings: any[] = [];
    
   
  //   if (invoiceData && Array.isArray(invoiceData.data)) {


  //    const filteredInvoices = invoiceData.data.filter((invoice: any) => {
  //    const matchCompany = selectedCompany ? Number(invoice.quoteWorkOrderCompanyId) === Number(selectedCompany) : true;
  //     const matchCustomer = selectedCustomer ? Number(invoice.quoteWorkOrderCustomerId) === Number(selectedCustomer) : true;

  //     return matchCompany && matchCustomer;
  //   });

      
  //     bookings = filteredInvoices.flatMap((invoice: any) =>
  //       invoice.quoteWorkOrderSale.map((sale: any) => ({
  //         title: `${invoice.quoteWorkOrderNo} | ${sale.productName} | ${dayjs(sale.departureDateTime).format('h:mm A')} ${
  //           sale.returnDateTime ? `- ${dayjs(sale.returnDateTime).format('h:mm A')}` : ''
  //         } | ${sale.transferTypeFrom} to ${sale.transferTypeTo} ${
  //           Array.isArray(invoice?.drivers) && invoice.drivers.length
  //             ? `(Drivers: ${invoice.drivers
  //                 .map((driver: { driverFirstName: string; driverLastName: string }) =>
  //                   `${capitalize(driver.driverFirstName)} ${capitalize(driver.driverLastName)}`
  //                 )
  //                 .join(', ')})`
  //             : ''
  //         }`,
  
  //         start: new Date(sale.departureDateTime), // Always set start as departure
  //         end: sale.returnDateTime ? new Date(sale.returnDateTime) : new Date(sale.departureDateTime), // If no return, set end same as start
  //         allDay: false,
  //         workOrderId: invoice.work_order_id,
  //       }))
  //     );
  //   }
  
  //   setEvents(bookings);
  // }, [ invoiceData,selectedCompany, selectedCustomer]);



//   useEffect(() => {
//   let inquiryEvents: any[] = [];

//   if (inquiryData && Array.isArray(inquiryData.data)) {
//     const filteredInquiries = inquiryData.data.filter((inq: any) => {
//       const matchCustomer = selectedCustomer ? Number(inq.customer_id) === Number(selectedCustomer) : true;
//       const matchStatus = selectedStatus ? Number(inq.status) === Number(selectedStatus) : true;
//       return matchCustomer && matchStatus;
//     });

//     inquiryEvents = filteredInquiries.map((inq: any) => ({
//       // title: `${inq.customer?.customerFirstName || ''} ${inq.customer?.customerLastName || ''} | ${inq.event_type || 'No Type'} | ${inq.message ? inq.message.substring(0, 20) + '...' : ''}`,
//       title: `${inq.customer?.customerFirstName || ''} ${inq.customer?.customerLastName || ''} | ${inq.event_type || 'No Type'} | ${inq.event_date ? dayjs(inq.event_date).format('DD-MMM-YYYY') : 'No Date'} | ${getInquiryStatusLabel(inq.status ?? InquiryStatus.New)}`,
//       // start: new Date(inq.event_date || inq.ctime || inq.created_at),
//       // end: new Date(inq.event_date || inq.ctime || inq.created_at),
//       start: new Date( inq.ctime || inq.created_at),
//       end: new Date( inq.ctime || inq.created_at),
//       allDay: false,
//       inquiryId: inq.id,
//       status: inq.status,
//       customer: inq.customer,
//       customerId: inq.customer_id,
//     }));
//   }

//   setEvents(inquiryEvents);
// }, [inquiryData, selectedCustomer, selectedStatus]);

 useEffect(() => {

 let inquiryEvents: any[] = [];

  if (inquiryData && Array.isArray(inquiryData.data)) {
    const filteredInquiries = inquiryData.data.filter((inq: any) => {
      const matchCustomer = selectedCustomer ? Number(inq.customer_id) === Number(selectedCustomer) : true;
      const matchStatus = selectedStatus ? Number(inq.status) === Number(selectedStatus) : true;
      return matchCustomer && matchStatus;
    });

    inquiryEvents = filteredInquiries.map((inq: any) => ({
      // title: `${inq.customer?.customerFirstName || ''} ${inq.customer?.customerLastName || ''} | ${inq.event_type || 'No Type'} | ${inq.message ? inq.message.substring(0, 20) + '...' : ''}`,
      title: `${inq.customer?.customerFirstName || ''} ${inq.customer?.customerLastName || ''} | ${inq.event_type || 'No Type'} | ${inq.event_date ? dayjs(inq.event_date).format('DD-MMM-YYYY') : 'No Date'} | ${getInquiryStatusLabel(inq.status ?? InquiryStatus.New)}`,
      // start: new Date(inq.event_date || inq.ctime || inq.created_at),
      // end: new Date(inq.event_date || inq.ctime || inq.created_at),
      start: new Date( inq.ctime || inq.created_at),
      end: new Date( inq.ctime || inq.created_at),
       backgroundColor: getInquiryStatusColor(inq.status ?? InquiryStatus.New),
      borderColor: getInquiryStatusColor(inq.status ?? InquiryStatus.New),
      extendedProps: {
        inquiryId: inq.id,
        status: inq.status,
        customer: inq.customer,
        customerId: inq.customer_id,
      },
      
    }));
  }

  setEvents(inquiryEvents);

  }, [inquiryData, selectedCustomer, selectedStatus]);


const handleEventClick = (info: any) => {
  const inquiryId = info.event.extendedProps.inquiryId;
  if (inquiryId) {
    navigate(`/customer-history/inquiry/${inquiryId}`);
  }
};

  


  return (


      <>
      <Grid container spacing={1} sx={{ marginTop: 1 }}>
           <Grid item xs={12}>
             <Card className={classes.card}>
          <Box mb={2} padding={2}>
          <Grid container spacing={2}>
          {/* <Grid item lg={2} md={2} sm={6} xs={12}>
            <Typography variant="subtitle1" sx={{ marginBottom: 1 }}>
              Issue From
            </Typography>
            <Select
              className={classes.textField}
              value={selectedCompany || ""}
              onChange={(event) => setSelectedCompany(event.target.value)}
              displayEmpty
              sx={{
                height: "37px",
                fontSize: "14px",
                padding: "4px",
                minWidth: "120px"
              }}
            >
              <MenuItem value="">All Companies</MenuItem>
              {companyData && Array.isArray(companyData.data) ? (
                companyData.data.map((company: any) => (
                  <MenuItem key={company.id} value={company.id}>
                    {`${capitalize(company.companyName)}`}
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>No data available</MenuItem>
              )}
            </Select>
          </Grid> */}
          
               <Grid item lg={2} md={2} sm={6} xs={12}>
            <Typography variant="subtitle1" sx={{ marginBottom: 1 }}>
              Customer
            </Typography>
            <Select
              className={classes.textField}
              value={selectedCustomer || ""}
              onChange={(event) => setSelectedCustomer(event.target.value)}
              displayEmpty
              sx={{
                height: "37px",
                fontSize: "14px",
                padding: "4px",
                minWidth: "120px"
              }}
            >
              <MenuItem value="">All Customers</MenuItem>
              {customerData && Array.isArray(customerData.data) ? (
                customerData.data.map((customer: any) => (
                  <MenuItem key={customer.id} value={customer.id}>
                   {`${capitalize(customer.customerFirstName || '')} ${capitalize(customer.customerLastName || '')}`}
          
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>No data available</MenuItem>
              )}
            </Select>
          </Grid>
<Grid item lg={2} md={2} sm={6} xs={12}>
            <Typography variant="subtitle1" sx={{ marginBottom: 1 }}>
              Status
            </Typography>
                            <Select
                            // label="Status"
                            className={classes.textField}
                            value={selectedStatus || ""}
                            onChange={(event) => setSelectedStatus(event.target.value)}
                            displayEmpty
                            sx={{
                              height: "37px",
                              fontSize: "14px",
                              padding: "4px",
                              minWidth: "120px"
                            }}
                          >
                         <MenuItem value="">All Status</MenuItem>
                        
                          {InquiryStatus && Object.keys(InquiryStatus).length > 0 ? (
                            Object.entries(InquiryStatus).map(([key, value], index) => (
                              <MenuItem key={index} value={String(value)}>
                                {key}
                              </MenuItem>
                            ))
                          ) : (
                            <MenuItem disabled>No data available</MenuItem>
                          )}
                              
                         
                          </Select>
 </Grid>
          
                     </Grid>
                   </Box>
                   </Card>
                   </Grid>
                   </Grid>

    {/* <div  style={{ height: 600, padding: "20px", backgroundColor: "#f8f9fa", borderRadius: "10px", boxShadow: "0px 4px 15px rgba(0,0,0,0.1)" }}>
  <Calendar
  localizer={localizer}
  events={events}
  startAccessor="start"
  endAccessor="end"
  style={{ height: "100%", whiteSpace: "normal" }}
  
  eventPropGetter={(event: any) => {
    const statusColor = getInquiryStatusColor(event.status ?? InquiryStatus.New);
    let backgroundColor = "#9e9e9e"; // default grey

    switch (statusColor) {
      case "success":
        backgroundColor = "#4caf50"; // green
        break;
      case "primary":
        backgroundColor = "#2196f3"; // blue
        break;
      case "warning":
        backgroundColor = "#ff9800"; // yellow
        break;
      case "error":
        backgroundColor = "#f44336"; // red
        break;
      default:
        backgroundColor = "#9e9e9e"; // grey
    }

    return {
      style: {
        backgroundColor,
        color: "#fff",
        borderRadius: "5px",
        padding: "4px",
        fontSize: "12px",
        whiteSpace: "normal",
        wordBreak: "break-word",
        overflow: "visible",
      },
    };
  }}

  onSelectEvent={handleEventClick}
/>

  </div> */}
  <Grid container spacing={1} sx={{ marginTop: 1 }}>
           <Grid item xs={12}>
             <Card className={classes.card}>
              <div style={{ padding: "20px"}}>

         
   {/* <Box style={{ padding: "20px", backgroundColor: "#f8f9fa", borderRadius: "10px", boxShadow: "0px 4px 15px rgba(0,0,0,0.1)" }}> */}
        <FullCalendar
          plugins={[dayGridPlugin, timeGridPlugin, listPlugin, interactionPlugin]}
          //initialView={isMobile ? "listWeek" : "dayGridMonth"}
          initialView="dayGridMonth"
          headerToolbar={{
            left: "prev,next today",
            center: "title",
            // right: isMobile ? "listWeek" : "dayGridMonth,timeGridWeek,timeGridDay",
            right: "dayGridMonth,timeGridWeek,timeGridDay,listWeek",
          }}
          events={events}
          height="auto"
          contentHeight="auto"
          themeSystem="bootstrap-premium"
          eventTextColor="#fff"
          eventClick={handleEventClick}
          eventDisplay="block" // ensures all events are shown
        />
      {/* </Box> */}
           </div>
      </Card>
      </Grid>
      </Grid>
  </>
  );
};

export default BookingCalendar;